import { styled } from 'styled-components';

import { COLORS, SHADOWS } from '@components/web/src/styles';

export const ProductFeedbackAnswerCardContainer = styled.div<{ $withGap: boolean }>`
  all: unset;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 46px;
  padding: 8px 16px;
  border-radius: 8px;
  background-color: ${COLORS.base.white};
  gap: ${({ $withGap }) => ($withGap ? '16px' : '0')};
  cursor: pointer;
`;

export const AnswerColor = styled.div<{ $hexColor?: string }>`
  min-width: 30px;
  max-width: 30px;
  height: 30px;
  border-radius: 4px;
  background: ${({ $hexColor }) => $hexColor};
  box-shadow: ${SHADOWS.md};
`;

export const AnswerImage = styled.div<{ $image?: string }>`
  min-width: 30px;
  max-width: 30px;
  height: 30px;
  border-radius: 4px;
  background: ${({ $image }) => $image};
  box-shadow: ${SHADOWS.md};
`;
